import {Directive, EventEmitter, HostListener, Output} from '@angular/core';

/**
 * Emits when the Escape key is pressed.
 */
@Directive({
  selector: '[motnEscapeKey]',
  standalone: true,
})
export class EscapeKeyDirective {
  @Output() motnEscapeKey = new EventEmitter<void>();

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.motnEscapeKey.emit();
  }
}
